import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Account Movements
@return { Array }
*/
export const getAccountMovements = state => state.accountsMovements

/** returns Last Movement releaseDatePosition orderNumberPosition info
@return { Object }
*/
export const getLastMovementInfo = state => state.lastMovementInfo

/** returns Account Movements hasMore value
@return { Boolean }
*/
export const getMovementsHasMore = state => state.movementsHasMore

/** returns Movements Categories
@return { Array }
*/
export const getMovementsCategories = state => state.movementsCategories
